import { useContext, useEffect } from 'react';

import { LoadingContext } from './LoadingContext';

export function useLoading(isLoading: boolean) {
  const ctx = useContext(LoadingContext);
  if (!ctx) throw new Error('useLoading must be used within LoadingProvider');

  useEffect(() => {
    if (isLoading) {
      ctx.increment();
      return () => ctx.decrement();
    }
  }, [ctx, isLoading]);
}
